export default "__VITE_ASSET__b28e11ff__"